import { useTheme } from '@mui/material';

export const ChatIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="192"
            height="102"
            viewBox="0 0 192 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 71.5635C0 60.5178 8.95431 51.5635 20 51.5635H56C67.0457 51.5635 76 60.5178 76 71.5635V102H20C8.95431 102 0 93.0455 0 81.9998V71.5635Z"
                fill={primaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.5273 77.1269C43.5273 80.1795 41.0526 82.6542 38 82.6542C34.9474 82.6542 32.4727 80.1795 32.4727 77.1269C32.4727 74.0743 34.9474 71.5996 38 71.5996C41.0526 71.5996 43.5273 74.0743 43.5273 77.1269ZM27.6366 77.127C27.6366 80.1796 25.1619 82.6543 22.1093 82.6543C19.0567 82.6543 16.582 80.1796 16.582 77.127C16.582 74.0744 19.0567 71.5997 22.1093 71.5997C25.1619 71.5997 27.6366 74.0744 27.6366 77.127ZM53.8909 82.6542C56.9435 82.6542 59.4182 80.1795 59.4182 77.1269C59.4182 74.0743 56.9435 71.5996 53.8909 71.5996C50.8383 71.5996 48.3636 74.0743 48.3636 77.1269C48.3636 80.1795 50.8383 82.6542 53.8909 82.6542Z"
                fill="white"
            />
            <path
                d="M191.5 30C191.5 13.7076 178.292 0.5 162 0.5H112C95.7076 0.5 82.5 13.7076 82.5 30V72.5H162C178.292 72.5 191.5 59.2924 191.5 43V30Z"
                fill="white"
                stroke={primaryStroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M152 37C152 41.4183 155.582 45 160 45C164.418 45 168 41.4183 168 37C168 32.5817 164.418 29 160 29C155.582 29 152 32.5817 152 37ZM129 37C129 41.4183 132.582 45 137 45C141.418 45 145 41.4183 145 37C145 32.5817 141.418 29 137 29C132.582 29 129 32.5817 129 37ZM114 45C109.582 45 106 41.4183 106 37C106 32.5817 109.582 29 114 29C118.418 29 122 32.5817 122 37C122 41.4183 118.418 45 114 45Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
